import Sentry from 'src/services/sentry/Sentry';

/**
 * Safely parses JSON data from localStorage with error handling and cleanup
 * @param storageKey - The localStorage key to read from
 * @param fallbackValue - The value to return if parsing fails or key doesn't exist (defaults to empty object)
 * @returns Parsed JSON data or fallback value if parsing fails
 */
const safelyParseLocalStorageJSON = <T = Record<string, any>>(
  storageKey: string,
  fallbackValue: T = {} as T
): T => {
  const stored = localStorage.getItem(storageKey);

  if (!stored) {
    return fallbackValue;
  }

  try {
    return JSON.parse(stored);
  } catch (error: any) {
    // Clear corrupted localStorage data
    localStorage.removeItem(storageKey);
    Sentry.captureException(error, {
      title: 'Failed to parse stored JSON data from localStorage',
      extra: {
        storageKey,
        storedValue: stored,
      },
    });
    return fallbackValue;
  }
};

export default safelyParseLocalStorageJSON;
